import React from "react";
import {ArrowRightIcon} from "@heroicons/react/16/solid";


export default function InformationCard({image, imageAlt, imageObject, imageDirection, text, subtext, ctaURL, ctaString}) {

    // Defaults to imageObject if provided, otherwise image

    // imageDirection either "right" or "left"
    return (
        <div
            className="elementor-element elementor-element-13b0a15 e-flex e-con-boxed e-con e-parent"
            data-id="13b0a15"
            data-element_type="container"
            id="tasks">
            <div className="e-con-inner">
                {
                    imageDirection === "left" && imageComponent()
                }
                <div
                    className="elementor-element elementor-element-8039c31 e-flex e-con e-child"
                    data-id="8039c31"
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-86264bd elementor-align-left animated-fast elementor-invisible elementor-widget elementor-widget-button"
                        data-id="86264bd"
                        data-element_type="widget"
                        data-settings='{"_animation":"fadeInUp"}'
                        data-widget_type="button.default"
                    >
                        <div className="elementor-widget-container">
                            <div className="elementor-button-wrapper">
                                <a
                                    className="elementor-button elementor-size-sm"
                                    role="button"
                                >
                                  <span className="elementor-button-content-wrapper">
                                    <span className="elementor-button-text">Tasks</span>
                                  </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-04e3ec4 elementor-widget elementor-widget-icon-box"
                        data-id="04e3ec4"
                        data-element_type="widget"
                        data-widget_type="icon-box.default"
                    >
                        <div className="elementor-widget-container">
                            <div className="elementor-icon-box-wrapper">
                                <div className="elementor-icon-box-content text-center md:text-left">

                                    <h2 className="elementor-icon-box-title mb-4">
                                        {text}
                                    </h2>
                                    <p className="elementor-icon-box-description">
                                        {subtext}

                                        {
                                            ctaURL &&
                                            <a
                                                href={ctaURL}
                                                className="font-semibold cursor-pointer flex flex-row items-center justify-center md:justify-start mt-4 mb-2 pb-2 md:mt-0 text-center"
                                            >
                                                <span>{ctaString || "Check it out"}</span>
                                                <ArrowRightIcon className="w-8 h-8 ml-2 "/>
                                            </a>
                                        }
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    imageDirection === "right" && imageComponent()
                }
            </div>
        </div>
    )

    function imageComponent() {
        return (
            <div
                className="elementor-element elementor-element-1ee596c e-con-full e-flex e-con e-child"
                data-id="1ee596c"
                data-element_type="container"
                data-settings='{"background_background":"classic"}'
            >
                <div
                    className="elementor-element elementor-element-a0880e0 elementor-widget elementor-widget-menu-anchor"
                    data-id="a0880e0"
                    data-element_type="widget"
                    data-widget_type="menu-anchor.default"
                >
                    <div className="elementor-widget-container">
                        <div className="elementor-menu-anchor" id="tasks"/>
                    </div>
                </div>
                <div
                    className="elementor-element elementor-widget elementor-widget-image"
                    data-id="8ee0213"
                    data-element_type="widget"
                    data-widget_type="image.default"
                >
                    <div className="">
                        <img
                            decoding="async"
                            width={373}
                            height={453}
                            src={image}
                            className="attachment-full size-full wp-image-1674"
                            alt={imageAlt ? imageAlt : "pabloo-store-credit-cashback"}
                            title={text}
                        />
                    </div>
                </div>
            </div>
        )
    }
}